/**
 * Module ID enum for type-safe module identification
 * Keep in sync with backend ModuleType enum
 */
export enum ModuleId {
  CAPABILITIES_V1 = 'CAPABILITIES_V1',
  CAPABILITIES_V2 = 'CAPABILITIES_V2',
  REPORTING = 'REPORTING',
  CHAT = 'CHAT',
  NOTIFICATIONS = 'NOTIFICATIONS',
  EXPORTS = 'EXPORTS',
  INTEGRATIONS = 'INTEGRATIONS',
  INVOICES = 'INVOICES',
}
